import { render, staticRenderFns } from "./MonthlyEmailSetting.vue?vue&type=template&id=9eafc250&scoped=true&"
import script from "./MonthlyEmailSetting.vue?vue&type=script&lang=ts&"
export * from "./MonthlyEmailSetting.vue?vue&type=script&lang=ts&"
import style0 from "./MonthlyEmailSetting.vue?vue&type=style&index=0&id=9eafc250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eafc250",
  null
  
)

export default component.exports